/** Where marketing CTAs / instant-quote continue should send the browser. */

/** Workspace home — never a marketing document path, so post-auth always loads the app shell. */
export const AUTH_SUCCESS_DEFAULT_HREF = "/overview";

/** Marketing "Get Label" / quote continue destination (app shell). */
export const GET_LABEL_HANDOFF_HREF = "/get-label";

export function isSafeInternalRedirectPath(path) {
  if (typeof path !== "string" || !path.startsWith("/") || path.startsWith("//")) return false;
  if (path.includes("://") || path.includes("\\")) return false;
  return true;
}

function isAuthDocumentPath(pathname) {
  const norm = String(pathname || "").split("?")[0].replace(/\/$/, "") || "/";
  return norm === "/login" || norm === "/signup" || norm === "/forgot-password";
}

/** Logged-out → marketing login (then get-label); logged-in → get-label. */
export function getMarketingGetLabelHandoffHref({
  loggedIn = typeof window !== "undefined" && !!window.nitromuleReactData?.userLoggedIn,
  afterLoginPath = GET_LABEL_HANDOFF_HREF
} = {}) {
  const target = isSafeInternalRedirectPath(afterLoginPath) ? afterLoginPath : GET_LABEL_HANDOFF_HREF;
  if (loggedIn) return target;
  return `/login?redirect=${encodeURIComponent(target)}`;
}

/**
 * Post-login destination. Defaults to /overview (workspace home).
 * Allows marketing page redirects (e.g. /solutions) so users can return where they were,
 * but never loops on /login or /signup.
 */
export function resolveAuthSuccessRedirectHref(search = typeof window !== "undefined" ? window.location.search : "") {
  try {
    const redirect = new URLSearchParams(search).get("redirect");
    if (isSafeInternalRedirectPath(redirect) && !isAuthDocumentPath(redirect)) {
      return redirect;
    }
  } catch (_) {}
  return AUTH_SUCCESS_DEFAULT_HREF;
}
